export default __webpack_public_path__ + "static/media/test-results.a31575df.jpg";